import React from 'react'
import styled from 'styled-components'
import { UserId, NlpModelId } from '@feedyou-ai/feedbot-schema'

import { useBotId } from '../../../store/flow'
import { useQueryMenuItems } from '../hooks/useQueryMenuItems'
import { MenuIcon } from '../../../components/design-system/MenuIcon'
import { DropdownMenu } from '../../../components/design-system/DropdownMenu'

interface Props {
  queryId: string
  userId: UserId
  modelId?: NlpModelId
  context?: string
  commitUserFilter: () => void
}

export const QueryMenuSettings: React.FC<Props> = props => {
  const botId = useBotId()
  const menuItems = useQueryMenuItems({ botId, ...props })

  return (
    <StyledDropdownMenus stopClickPropagation items={menuItems}>
      <SettingsIconWrapper>
        <MenuIcon data-test="intent-menu-trigger" />
      </SettingsIconWrapper>
    </StyledDropdownMenus>
  )
}

export const SettingsIconWrapper = styled.div`
  width: 35px;
  align-self: stretch;
  margin-right: -10px;
`

const StyledDropdownMenus = styled(DropdownMenu)`
  margin-top: -30px;
`
